var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('header-pane',{staticClass:"home-page__header",attrs:{"colorType":"light","pageTitle":_vm.$tc('HomePage.pageTitle')}}),_c('home-pane'),_c('global-navigation-pane',{attrs:{"current":"home"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }